// components/gallery/PhotoGrid/index.jsx
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { galleryService } from '../../../services/gallery.service';
import PhotoViewer from '../PhotoViewer';
import LoadingScreen from '../../common/loading/LoadingScreen';
import {
    GridContainer,
    PhotoCard,
    Photo,
    PhotoInfo,
    PhotoTitle,
    PhotoCaption
} from './styles';

const PhotoGrid = () => {
    const { topicId } = useParams();
    const [photos, setPhotos] = useState([]);
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPhotos = async () => {
            try {
                const data = await galleryService.getPhotosByTopic(topicId);
                setPhotos(data);
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPhotos();
    }, [topicId]);

    if (loading) return <LoadingScreen />;

    return (
        <>
            <GridContainer>
                {photos.map((photo) => (
                    <PhotoCard key={photo.id} onClick={() => setSelectedPhoto(photo)}>
                        <Photo 
                            src={photo.imageUrl} 
                            alt={photo.title} 
                            loading="lazy"
                        />
                        <PhotoInfo>
                            <PhotoTitle>{photo.title}</PhotoTitle>
                            <PhotoCaption>{photo.caption}</PhotoCaption>
                        </PhotoInfo>
                    </PhotoCard>
                ))}
            </GridContainer>

            {selectedPhoto && (
                <PhotoViewer
                    photo={selectedPhoto}
                    onClose={() => setSelectedPhoto(null)}
                    photos={photos}
                />
            )}
        </>
    );
};

export default PhotoGrid;